<template>
  <div>
    <div class="store-auto-response-item">
      <div
        v-show="!isEdit"
        class="store-auto-response-view"
      >
        <div class="store-auto-tool">
          <v-btn
            class="mr-2 ml-auto"
            small
            icon
            color="primary-001"
            @click="editAutoReply"
          >
            <v-icon
              size="18"
              width="18"
              class="auto-response-icon"
              height="18"
            >
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            class="ml-auto"
            small
            icon
            color="primary-001"
            @click="openDeleteCheckModal"
          >
            <v-icon
              size="22"
            >
              $vuetify.icons.trashCanIcon
            </v-icon>
          </v-btn>
        </div>
        <div class="store-auto-response-name mb-6">
          <h4 class="text-body-3 neutral-cold-051--text mb-2">
            {{ $t('STAFF_MANAGEMENT.SHOP_LOCATIONS') }}：
          </h4>
          <p class="text-body-1 neutral-040--text">
            {{ locationNameAndCode }}
          </p>
        </div>
        <div class="store-auto-response-content">
          <h4 class="text-body-3 neutral-cold-051--text mb-2">
            {{ $t('STAFF_MANAGEMENT.AUTO_REPLY_MESSAGE') }}：
          </h4>
          <p class="text-body-1 neutral-040--text mb-2">
            {{ replyBody }}
          </p>
        </div>
      </div>
      <!-- 編輯分店自動回覆 component -->
      <StoreAutoReplySetting
        v-show="isEdit"
        :location-code.sync="tempAutoReply.locationCode"
        :reply-body.sync="tempAutoReply.replyBody"
        :is-submit-loading="isSubmitLoading"
        @cancel-setting="$emit('change-is-edit', false)"
        @confirm-setting="updateAutoReply"
        :is-update-status="true"
      />
    </div>
    <Modal
      ref="deleteModal"
    >
      <template v-slot:actions>
        <v-card-actions class="pa-0 pt-8">
          <v-spacer />
          <v-btn
            color="neutral-045"
            outlined
            @click="$refs.deleteModal.closeModal();"
            class="text-body-2 cancel-btn"
          >
            {{ $t('CANCEL') }}
          </v-btn>
          <v-btn
            color="danger-022"
            outlined
            :loading="isDeleteBtnLoading"
            @click="deleteAutoReply"
            class="text-body-2 ml-3"
          >
            {{ $t('DELETE') }}
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
    <Notification
      ref="notification"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Modal from '@/components/Modal.vue';
import staffApi from '@/restapis/staffManagement';

import StoreAutoReplySetting from './StoreAutoReplySetting.vue';

export default {
  name: 'StoreAutoReply',
  components: {
    Modal,
    StoreAutoReplySetting
  },
  props: {
    locationCode: {
      type: String,
      default: ''
    },
    locationNameAndCode: {
      type: String,
      default: ''
    },
    replyBody: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    isDisableSaveBtn() {
      return this.tempAutoReply.replyBody === '';
    }
  },
  data() {
    return {
      isSubmitLoading: false,
      isDeleteBtnLoading: false,
      tempAutoReply: {
        locationCode: '',
        replyBody: ''
      }
    };
  },
  methods: {
    editAutoReply() {
      this.$emit('change-is-edit', true);
      this.tempAutoReply.locationCode = this.locationCode;
      this.tempAutoReply.replyBody = this.replyBody;
    },
    async updateAutoReply() {
      const data = this.tempAutoReply;
      this.isSubmitLoading = true;
      try {
        const response = await staffApi.updateOfflineAutoReply(data);
        if (response.status === 200) {
          const notificationObj = {
            title: this.$t('STAFF_MANAGEMENT.SETUP_HAS_BEEN_CHANGED'),
            status: 'success'
          };
          this.$refs.notification.openNotification(notificationObj);
        }
        this.isSubmitLoading = false;
        this.$emit('reload-Auto-Reply-List');
      } catch (error) {
        this.isSubmitLoading = false;
        const { code, message } = error.response.data;
        const notificationObj = {
          title: this.$t('ERROR_MSG.UPDATE_FAIL'),
          content: `${code}-${message}`
        };
        this.$refs.notification.openNotification(notificationObj);
      }
    },
    openDeleteCheckModal() {
      const title = this.$t('STAFF_MANAGEMENT.CHECK_DELETE_OFFLINE_AUTO_REPLY');

      this.$refs.deleteModal.openModal(title, '');
    },
    async deleteAutoReply() {
      this.isDeleteBtnLoading = true;
      try {
        const { data } = await staffApi.deleteOfflineAutoReply(this.locationCode);
        if (data.success) {
          this.$emit('auto-reply-delete-success');
        }
        this.$refs.deleteModal.closeModal();
        this.$emit('reload-Auto-Reply-List');
        this.isDeleteBtnLoading = false;
      } catch (error) {
        const { code, message } = error.response.data;
        const notificationObj = {
          title: this.$t('ERROR_MSG.DELETE_FAIL'),
          content: `${code}-${message}`
        };
        this.$refs.notification.openNotification(notificationObj);
        this.$refs.deleteModal.closeModal();
        this.isDeleteBtnLoading = false;
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>

::v-deep.cancel-btn {
  .v-btn__content {
    color: $neutral-cold-051;
  }
}
.store-auto-response-item {
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  .store-auto-response-view {
    background-color: $primary-005;
    border-radius: 4px;
    padding: 20px 24px;
    position: relative;
    .store-auto-tool {
      position: absolute;
      top: 20px;
      right: 24px;
    }
  }
}

::v-deep.auto-response-icon.v-icon {
  width: 18px;
  height: 18px;
}
</style>
